import React from "react";
import Box from "@mui/material/Box";
import TextField from "@mui/material/TextField";
import Autocomplete from "@mui/material/Autocomplete";
import { getCostCenterValue } from "../capture/FieldsIdentifiers";

export default function EditableCostCenterFilter({ 
  costCenter, 
  costCenters = [], 
  onCostCenterChange,
  label = "Cost Center",
  mb = 2 
}) {
  const handleCostCenterChange = (event, newValue) => {
    onCostCenterChange(newValue);
  };

  return (
    <Box mb={mb}>
      <Autocomplete
        value={costCenter}
        onChange={handleCostCenterChange}
        options={costCenters}
        getOptionLabel={option => getCostCenterValue(option) || ""}
        isOptionEqualToValue={(option, value) => option.id === value?.id}
        renderInput={params => (
          <TextField 
            {...params} 
            label={label} 
            variant="outlined" 
            fullWidth 
            size="small" 
          />
        )}
        clearable
      />
    </Box>
  );
} 